import { useContext } from "react";
import { FaChevronCircleUp } from "react-icons/fa";
import { AppContext } from "../context/AppContext";

const ScrollUpBtn = () => {

    const {offset} = useContext(AppContext)

    const scrollUp = () => {
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    return (
        <div className={`${(offset > 0) ? " scale-100" : " scale-0"} transition z-[100000] fixed inline-block bottom-4 right-4`} onClick={scrollUp}>
            <div className=" text-4xl text-tripstore-black cursor-pointer hover:text-tripstore-gold active:scale-95 rounded-full overflow-hidden shadow-md">
                <FaChevronCircleUp />
            </div>
        </div>
    )
}

export default ScrollUpBtn